import { titleCase } from "./hooks";
import type { Field } from "../components/EntityForm";

/**
 * The feedback register's form fields, shared by the Quality registers page
 * and the Website inbox's "record in register" promote. One definition so a
 * submission recorded from either place produces the same record.
 */

const SEVERITY = ["low", "medium", "high", "critical"].map((s) => ({ value: s, label: titleCase(s) }));

export interface FeedbackFieldDeps {
    participants: Array<{ id: string; full_name: string }>;
    /** Promoting from the website: the type is already known from the form. */
    lockType?: boolean;
}

export const feedbackRegisterFields = ({ participants, lockType }: FeedbackFieldDeps): Field[] => [
    ...(lockType ? [] : [{
        name: "submissionType", label: "This is a", kind: "select" as const, required: true,
        options: [
            { value: "complaint", label: "Complaint" },
            { value: "feedback", label: "Feedback" },
            { value: "compliment", label: "Compliment" },
        ],
        help: "This chooses the reference: complaints take TC-CML, compliments TC-CMP, feedback TC-FBK.",
    }]),
    { name: "description", label: "What would you like to tell us?", kind: "textarea", required: true },
    { name: "outcomeSought", label: "What outcome are you seeking?", kind: "textarea" },
    { name: "submissionFormality", label: "Formality", kind: "select", half: true,
      options: [
          { value: "informal_enquiry", label: "Informal enquiry" },
          { value: "formal_complaint", label: "Formal complaint" },
      ] },
    { name: "riskRating", label: "Risk rating", kind: "select", options: SEVERITY, half: true },
    { name: "category", label: "Category", kind: "text", half: true },
    { name: "occurredOn", label: "Date it happened", kind: "date", half: true },
    { name: "anonymous", label: "Submitted anonymously", kind: "checkbox", half: true,
      help: "Ticking this discards the contact details below rather than storing them." },
    { name: "submitterName", label: "Their name", kind: "text", half: true },
    { name: "submitterEmail", label: "Their email", kind: "email", half: true },
    { name: "submitterPhone", label: "Their phone", kind: "tel", half: true },
    { name: "affectedName", label: "Person affected", kind: "text", half: true },
    { name: "participantId", label: "Participant", kind: "searchselect",
      options: participants.map((p) => ({ value: p.id, label: p.full_name })), half: true },
];
